import React from 'react';
import {AdminSettingsNavItem} from "../../../../components/admin/AdminSettingsLayout";
import PanelTextNav from "./PanelTextNav";
import "../../../../components/admin/adminMenu.css";
import "./codeManageSettings.css";

function CodeManageSettingsLayout({
    navItems,
    activeCategory,
    sidebarActiveCategory,
    navDividerAfterId,
    onCategoryChange,
    panelTitle,
    panelDescription,
    panelHeadActions,
    panelSubNav,
    panelSubNavValue,
    onPanelSubNavChange,
    list,
    editor,
    fullPanel,
}) {
    const sidebarActive = sidebarActiveCategory ?? activeCategory;

    return (
        <div className="code-manage-layout">
            <div className="code-manage-layout__workspace">
                <aside className="admin-settings-sidebar" aria-label="코드 유형">
                    {navItems.map((item) => (
                        <React.Fragment key={item.id}>
                            <AdminSettingsNavItem
                                targetId={item.id}
                                label={item.label}
                                active={sidebarActive === item.id}
                                onClick={onCategoryChange}
                            />
                            {navDividerAfterId === item.id && (
                                <div className="code-manage-nav__divider" role="separator" />
                            )}
                        </React.Fragment>
                    ))}
                </aside>

                <main className="admin-settings-main code-manage-layout__main">
                    <div className="admin-settings-panel code-manage-layout__panel">
                        <header className="admin-settings-panel__head code-manage-panel__head">
                            <div className="code-manage-panel__head-row">
                                <h2 className="admin-settings-panel__title">{panelTitle}</h2>
                                {panelHeadActions && (
                                    <div className="code-manage-panel__head-actions code-manage-scope">
                                        {panelHeadActions}
                                    </div>
                                )}
                            </div>
                            {panelDescription && (
                                <div className="code-manage-panel__desc-row">
                                    <p className="admin-settings-panel__desc">{panelDescription}</p>
                                    {panelSubNav?.length > 0 && (
                                        <PanelTextNav
                                            ariaLabel="자산그룹 관리"
                                            options={panelSubNav}
                                            value={panelSubNavValue}
                                            onChange={onPanelSubNavChange}
                                        />
                                    )}
                                </div>
                            )}
                        </header>
                        {fullPanel ? (
                            <div className="code-manage-panel__body code-manage-panel__body--full">
                                <div className="code-manage-panel__full">{fullPanel}</div>
                            </div>
                        ) : (
                            <div className="code-manage-panel__body">
                                <div className="code-manage-panel__list code-manage-scope">{list}</div>
                                <div className="code-manage-panel__editor code-manage-scope">{editor}</div>
                            </div>
                        )}
                    </div>
                </main>
            </div>
        </div>
    );
}

export default CodeManageSettingsLayout;
